const SECRET_NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;

export const SECRET_NAME_ERROR =
  'Secret names can only contain letters, numbers, and underscores, and must start with a letter or underscore.';

export const DUPLICATE_SECRET_NAME_WARNING =
  'A secret with this name already exists. Choose a different name or edit the existing secret.';

export const validateSecretName = (name: string) =>
  SECRET_NAME_PATTERN.test(name);

export const hasDuplicateSecretName = (
  secretName: string,
  existingSecretNames: readonly string[]
) =>
  secretName !== '' &&
  existingSecretNames.some(
    existing => existing.toLowerCase() === secretName.toLowerCase()
  );
